import React, { useState } from "react";
import { Modal } from "antd";
import PropTypes from "prop-types";
import { hideLoader, showLoader } from "../../utils/loader";
import { customBaseUrl, httpPost } from "../../store/http";
import Swal from "sweetalert2";

const MassUpload = ({ hideModal, showModal }) => {
  const [postData, setPostData] = useState({});

  const handleSubmitFile = async (e) => {
    e.preventDefault();

    showLoader();

    let d = new Date();
    let reqId = d.getTime();
    let formData = new FormData();
    formData.append("file", postData?.file);
    formData.append("customerName", `Mass ${showModal === 'massCredit' ? 'Credit' : 'Debit'}`);
    formData.append("requestId", reqId);
    formData.append("requestType", showModal);
    
    let customerName = `Mass ${showModal === 'massCredit' ? 'Credit' : 'Debit'}`;
    let response = await httpPost(`${customBaseUrl.logUrl}/api/v1/requestlog/create/bulk/${reqId}/${customerName}/${showModal}`, formData);

    hideLoader();
    if (response?.status) {
      Swal.fire('Done', response.message, 'success');
      hideModal('');
    } else {
      Swal.fire('Error', response.message, 'error');
    }
  };

  return (
    <Modal
      title={`Mass ${showModal === 'massCredit' ? 'Credit' : 'Debit'} Transaction`}
      centered
      visible={!!showModal}
      onCancel={() => hideModal('')}
      width={500}
      footer={null}
    >
      <form className='row g-3 needs-validation' noValidate>
        <div className='col-10 mt-5 mb-3 mx-auto'>
          <div className='input-group'>
            <input
              type='file'
              className='form-control'
              id='inputGroupFile02'
              onChange={(e) => setPostData({ ...postData, file: e.target.files[0] })}
            />
            <div className='invalid-feedback'>File is required.</div>
          </div>
        </div>

        <div className='col-12 text-center mt-5'>
          <button className='btn btn-primary' type='submit' onClick={handleSubmitFile}>
            Submit form
          </button>
        </div>
      </form>
    </Modal>
  );
};

MassUpload.propTypes = {
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.string.isRequired,
};

export default MassUpload;